import { FetchStore } from "@root/data/lib";
import { GitHubPR, IGitHubPR } from "./github-pr-model";
import { apiGateway } from "@root/lib/http";
import { API } from "./constants";

interface GitHubPRParams {
  installationId: string;
  ownerName: string;
  repositoryName: string;
  accessTokenId: string;
  githubUserId: string;
}

class GitHubPRStoreFetchStore extends FetchStore<GitHubPR, IGitHubPR, GitHubPRParams> {
  protected fetchData(params: GitHubPRParams): Promise<IGitHubPR> {
    return apiGateway.get<IGitHubPR>(API.GITHUB_LATEST_PR, {
      params: {
        installationId: params.installationId,
        ownerName: params.ownerName,
        repositoryName: params.repositoryName,
      },
      headers: {
        "access-token-id": params.accessTokenId,
        "github-user-id": params.githubUserId,
      },
    });
  }

  protected deserialize(pr: IGitHubPR): GitHubPR {
    return pr as GitHubPR;
  }
}

export const githubPRStore = new GitHubPRStoreFetchStore();
